import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import { SaveStatusProvider } from './contexts/SaveStatusContext';
import ProtectedRoute from './components/ProtectedRoute';
import Whiteboard from './components/Whiteboard';
import UserMenu from './components/UserMenu';
import LandingLayout from './components/landing/components/layout/Layout';
import HomePage from './components/landing/pages/HomePage';
import PricingPage from './components/landing/pages/PricingPage';
import ContactPage from './components/landing/pages/ContactPage';
import ImpressumPage from './components/landing/pages/ImpressumPage';
import PrivacyPage from './components/landing/pages/PrivacyPage';
import TermsPage from './components/landing/pages/TermsPage';
import SubscriptionSuccessPage from './components/landing/pages/SubscriptionSuccessPage';
import SubscriptionCancelPage from './components/landing/pages/SubscriptionCancelPage';
import { isFirebaseInitialized } from './config/firebase';
import { isPrerendering } from './utils/prerender';
import './App.css';

function App() {
  const [firebaseReady, setFirebaseReady] = useState(false);

  useEffect(() => {
    if (isPrerendering()) {
      setFirebaseReady(true);
      return;
    }

    // Check if Firebase is initialized
    const checkFirebase = () => {
      if (isFirebaseInitialized()) {
        setFirebaseReady(true);
      } else {
        // Retry after a short delay
        setTimeout(checkFirebase, 100);
      }
    };

    checkFirebase();
  }, []);

  const prerender = isPrerendering();

  // Show loading while Firebase initializes (only in real browser, not during prerender)
  if (!prerender && !firebaseReady) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Initializing Firebase...
      </div>
    );
  }

  return (
    <AuthProvider>
      <SaveStatusProvider>
        <Router>
          <Routes>
            {/* Landing page routes */}
            <Route path="/" element={
              <LandingLayout>
                <HomePage />
              </LandingLayout>
            } />
            <Route path="/pricing" element={
              <LandingLayout>
                <PricingPage />
              </LandingLayout>
            } />
            <Route path="/contact" element={
              <LandingLayout>
                <ContactPage />
              </LandingLayout>
            } />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            
            {/* Subscription related routes */}
            <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />
            <Route path="/subscription/cancel" element={<SubscriptionCancelPage />} />
            
            {/* Whiteboard app route */}
            <Route path="/app" element={
              <ProtectedRoute>
                <div className="app">
                  <Whiteboard />
                  <UserMenu />
                </div>
              </ProtectedRoute>
            } />
            
            {/* Redirect /app to / if not authenticated */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </SaveStatusProvider>
    </AuthProvider>
  );
}

export default App;
